/**
 * Angular imports.
 */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

/**
 * Service imports.
 */
import { FunCollectionService } from '../common/common-functions/fun-collection.service';

import { NewLanguageService } from '../dataservices/new-language/new-language.service';

/**
 * Auth Guard for restricting modules in case user comes from no login
 */
@Injectable({
  providedIn: 'root'
})
export class openAccessGuard {

  /**
   * Necessary instances.
   */
  constructor(
    private fcs: FunCollectionService,
    private mls: NewLanguageService
  ) {

  }

  /**
   * canLoad guard for moudules
   * @param next
   * @returns
   */
  canLoad(next: ActivatedRouteSnapshot): boolean {
    return this.canRoute(next);
  }
  /**
   * can route be accesed
   * @param next
   * @returns
   */
  canActivate(next: ActivatedRouteSnapshot): boolean {
    return this.canRoute(next);
  }
  /**
   * function to validate route
   */
  canRoute(next: ActivatedRouteSnapshot): boolean {
    if (this.mls.userLoginFlow == 1 && this.mls.featureOnOffList.moduleList[next.data.moduleName.name].value === false) {
      this.fcs.navigateToHome();
      this.mls.toShowNologinRestrictionPopUp = true;
      return false;
    }
    else {
      return true;
    }
  }
}
